import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import './HavaDurumu.css';

const fetcher = async (url) => {
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
    });

    if (!response.ok) {
        throw new Error('Hava durumu alınamadı.');
    }

    return response.json();
};

function HavaDurumu() {
    const { data: sehirler, error } = useSWR('/api/hava-durumu', fetcher, {
        refreshInterval: 900000,
        revalidateOnFocus: false
    });
    const [aktifIndex, setAktifIndex] = useState(0);
    const [gorunur, setGorunur] = useState(true);

    useEffect(() => {
        if (!sehirler?.length) return undefined;

        const interval = setInterval(() => {
            setGorunur(false);
            setTimeout(() => {
                setAktifIndex(index => (index + 1) % sehirler.length);
                setGorunur(true);
            }, 250);
        }, 4500);

        return () => clearInterval(interval);
    }, [sehirler]);

    if (error || !sehirler?.length) return null;

    const aktifSehir = sehirler[aktifIndex];

    return (
        <div className={`hava-durumu-karti ${gorunur ? 'gorunur' : 'gizli'}`}>
            <span className="hava-durumu-ikon" aria-hidden="true">{aktifSehir.ikon}</span>
            <span className="hava-durumu-sehir">{aktifSehir.sehir}</span>
            <span className="hava-durumu-derece">{aktifSehir.derece}°</span>
        </div>
    );
}

export default HavaDurumu;
